import React from "react"
import {Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {RootState} from "../../../Redux";

interface SpecialInspectionButtonProps {
    handleSelect: (action: string) => void
}

const SpecialInspectionButton = ({handleSelect}: SpecialInspectionButtonProps) => {
    const { t } = useTranslation()

    const changeInspectionAvailable = useSelector(
        (state: RootState) => state.ui.settings.selfService.changeInspectionAvailable) || false;
    const registrationInspectionAvailable = useSelector(
        (state: RootState) => state.ui.settings.selfService.registrationInspectionAvailable) || false;
    const showButton = changeInspectionAvailable || registrationInspectionAvailable

    if (!showButton) {
        return <></>
    }

    const getText = () => {
        if (changeInspectionAvailable && registrationInspectionAvailable) {
            return t('selfService.modificationInspection') + ', ' + t('selfService.registrationInspection')
        } else if (changeInspectionAvailable) {
            return t('selfService.modificationInspection')
        } else if (registrationInspectionAvailable) {
            return t('selfService.registrationInspection')
        }
    }

    const handleAction = () => {
        if (changeInspectionAvailable && registrationInspectionAvailable) {
            handleSelect("specialInspection")
        } else if (changeInspectionAvailable) {
            handleSelect("changeInspection")
        } else if (registrationInspectionAvailable) {
            handleSelect("registrationInspection")
        }
    }

    return (
        <Button
            variant={"contained"}
            onClick={handleAction}
        >
            {getText()}
        </Button>
    )
}

export default SpecialInspectionButton
